import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum FieldSetTypeIds {
  SPEC = 1,
  ORDER_DETAILS = 2,
}

export function getFieldSetTypes(): ISelectItem[] {
  return [
    { id: FieldSetTypeIds.SPEC, label: 'Spec' },
    { id: FieldSetTypeIds.ORDER_DETAILS, label: 'Order Details' },
  ]
}

export const getFieldSetTypeByLabel = getItemByLabelFactory(getFieldSetTypes)
export const getFieldSetTypeById = getItemByIdFactory(getFieldSetTypes)
